<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工单处理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 状态 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="tabs_style">
      <el-tab-pane label="当前工单" name="first">
        <!-- 查询 -->
        <el-form :inline="true" :model="formInline">
          <el-form-item label="车辆编号:">
            <el-input size="small" v-model="formInline.vin" placeholder="输入车辆编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="提交人:">
            <el-select size="small" clearable filterable v-model="formInline.submitter" placeholder="请选择提交人">
              <el-option v-for="item in currentPersonOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题描述:">
            <el-input size="small" v-model="formInline.description" placeholder="输入问题描述" clearable></el-input>
          </el-form-item>
          <el-form-item label="提交时间:">
            <div class="block">
              <el-date-picker v-model="formInline.submit_day" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                size="small">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
          <el-table-column align="center" prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column align="center" prop="faultList.vin" min-width="200" label="车辆编号">
          </el-table-column>
          <el-table-column align="center" prop="userCustomer.name" min-width="100" label="提交人">
            <template slot-scope="scope">
              <div v-if="scope.row.userCustomer">{{ scope.row.userCustomer.name }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="userCustomer.phone" min-width="150" label="联系方式">
            <template slot-scope="scope">
              <div v-if="scope.row.userCustomer">{{ scope.row.userCustomer.phone }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="faultList.equipment_name" min-width="150" label="故障系统">
          </el-table-column>
          <el-table-column align="center" prop="faultList.fault_details" min-width="200" label="故障详情">
          </el-table-column>
          <el-table-column align="center" width="100" label="车辆定位">
            <div slot-scope="scope">
              <!-- <span class="car_jl"> {{ scope.row.faultList.lng }},{{ scope.row.faultList.lat }} </span> -->
              <el-button size="mini" icon="el-icon-location" type="warning" circle @click="showmap(scope.row)">
              </el-button>
            </div>
          </el-table-column>
          <el-table-column align="center" prop="description" min-width="300" label="问题描述">
          </el-table-column>
          <el-table-column align="center" prop="create_time_str" min-width="300" label="提交时间">
          </el-table-column>
          <el-table-column align="center" prop="status" min-width="150" label="工单状态">
            <template slot-scope="scope">
              <el-tag :color="scope.row.status_type" style="color:white">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="150"
            v-if="check_auth('/web/fault-repair-order/submit') || check_auth('/web/fault-repair-order/handle')">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"
                v-if="check_auth('/web/fault-repair-order/submit')">
              </el-button>
              <el-button size="mini" type="success" icon="el-icon-check" circle @click="handleStatus(scope.row)"
                v-if="check_auth('/web/fault-repair-order/handle')">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="历史工单" name="second">
        <!-- 查询 -->
        <el-form :inline="true" :model="successFormInline">
          <el-form-item label="车辆编号:">
            <el-input size="small" v-model="successFormInline.vin" placeholder="输入车辆编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="提交人:">
            <el-select size="small" clearable filterable v-model="successFormInline.submitter" placeholder="请选择押车人">
              <el-option v-for="item in PersonOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题描述:">
            <el-input size="small" v-model="successFormInline.description" placeholder="输入问题描述" clearable></el-input>
          </el-form-item>
          <el-form-item label="提交时间:">
            <div class="block">
              <el-date-picker v-model="successFormInline.submit_day" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" size="small">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="searchSuccess">搜索</el-button>
          </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table size="small" :data="tableData" highlight-current-row border style="width: 100%">
          <el-table-column align="center" prop="id" label="ID" width="80">
          </el-table-column>
          <el-table-column align="center" prop="vin" min-width="200" label="车辆编号">
          </el-table-column>
          <el-table-column align="center" prop="name" min-width="100" label="提交人">
            <template slot-scope="scope">
              <div v-if="scope.row.name">{{ scope.row.name }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="phone" min-width="150" label="联系方式">
            <template slot-scope="scope">
              <div v-if="scope.row.phone">{{ scope.row.phone }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="equipment_name" min-width="150" label="故障系统">
          </el-table-column>
          <el-table-column align="center" prop="fault_details" min-width="200" label="故障详情">
          </el-table-column>
          <el-table-column align="center" min-width="100" label="车辆定位">
            <div slot-scope="scope">
              <!-- <span class="car_jl"> {{ scope.row.faultList.lng }},{{ scope.row.faultList.lat }} </span> -->
              <el-button size="mini" icon="el-icon-location" type="warning" circle @click="showmap(scope.row)">
              </el-button>
            </div>
          </el-table-column>
          <el-table-column align="center" prop="description" min-width="300" label="问题描述">
          </el-table-column>
          <el-table-column align="center" prop="create_time" min-width="300" label="提交时间">
          </el-table-column>
          <el-table-column align="center" prop="status" min-width="150" label="工单状态">
            <template slot-scope="scope">
              <el-tag :color="scope.row.status_type" style="color:white">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="deal" min-width="200" label="处理结果">
          </el-table-column>
          <el-table-column align="center" prop="next_person_name" min-width="200" label="转接人">
          </el-table-column>
          <el-table-column align="center" prop="dd_description" min-width="200" label="转接人处理结果">
            <template slot-scope="scope">
              <el-tag :color="scope.row.description_type" style="color:white" v-if="scope.row.dd_description">{{
                scope.row.dd_description
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="page_parm.currentPage" background :page-sizes="[5, 10, 15, 25, 50, 100]"
          :page-size="page_parm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page_parm.total">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- 编辑弹框 -->
    <el-dialog title="编辑工单" :visible.sync="dialogFormVisible" width="35%" @close="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="问题描述" label-width="70px">
          <el-input type="textarea" size="mini" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="转接人" label-width="70px">
          <el-select size="mini" v-model="form.user_id" @click="editClick()" filterable clearable placeholder="请选择转接人"
            style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" size="small">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-left: 10%">
        <el-button size="mini" type="primary" @click="submitEdit">确 定</el-button>
        <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="deal" title="提交处理" width="35%" @close="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="处理结果" prop="opinion">
          <el-input v-model="ruleForm.opinion" placeholder="请输入处理结果"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 地图 -->
    <el-dialog :visible.sync="show" title="车辆位置" @close="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <div id="container"></div>
    </el-dialog>
  </div>
</template>
<script>
let conmap = "";
let marker = "";
let map_status = true;
import AMapLoader from "@amap/amap-jsapi-loader";
import Pagination from "../../components/Pagination";
import {
  get_faultoder_list,
  get_history_order,
  get_faultoder_get_users,
  get_faultoder_edit,
  get_faultoder_switch_status,
  get_lng_lat,
} from "../../api/operation/faultoder";
import {
  auth
} from "../../utils/util";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      show: false,
      deal: false,
      activeName: "first",
      listData: [],
      tableData: [],
      PersonOptions: [],
      currentPersonOptions: [],
      formInline: {
        description: "",
        submitter: "",
        vin: "",
        submit_day: "",
        page: 1,
        limit: 10,
      },
      ruleForm: {
        id: "",
        opinion: "",
      },
      successFormInline: {
        description: "",
        submitter: "",
        vin: "",
        submit_day: "",
        page: 1,
        limit: 10,
      },
      options: [],
      lnglat: [],
      gps_type: "",
      form: {
        id: "",
        description: "",
        user_id: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      page_parm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      rules: {
        opinion: [
          { required: true, message: '请输入处理结果', trigger: 'blur' },
        ],
        description: [
          {
            required: true,
            message: "请输入问题描述",
            trigger: "blur",
          },
        ]
      },
      p_id: "",
      course: "",
      timer: null,
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.activeName = 'first';
    this.getdata();
    this.getCurrentPerson()
  },
  methods: {
    check_auth(val) {
      return auth(val);
    },
    // 地图
    showmap(row) {
      map_status = true;
      this.p_id = ""
      this.show = !this.show;
      this.p_id = row.id;
      get_lng_lat(this.p_id).then((res) => {
        this.gps_type = res.data.gps_type;
        if (res["code"] !== 0) {
          return
        }
        if (res.data.lng == '-' && res.data.lat == '-') {
          if (map_status) {
            //创建地图
            conmap = new AMap.Map("container", {
              resizeEnable: true, //是否监控地图容器尺寸变化
              zoom: 18, //初始化地图层级
              center: [118.216513, 36.810216], //初始化地图中心点
            })
          };
        } else {
          if (map_status) {
            //创建地图
            AMap.convertFrom(([res.data.lng, res.data.lat]), this.gps_type, function (status, result) {
              if (result.info === 'ok') {
                var resLnglat = result.locations[0];
                conmap = new AMap.Map("container", {
                  resizeEnable: true, //是否监控地图容器尺寸变化
                  zoom: 18, //初始化地图层级
                  center: [resLnglat.lng, resLnglat.lat], //初始化地图中心点
                });
              }
            });
          }
          this.timer = setInterval(() => {
            this.guiji();
          }, 1000);
        }
      });
    },
    guiji() {
      get_lng_lat(this.p_id).then((res) => {
        this.gps_type = res.data.gps_type;
        this.course = res.data.current_angele;
        if (res["code"] !== 0) {
          return
        }
        if (res.data.lng == '-' && res.data.lat == '-') {
          var viaMarker = new AMap.Marker({
            position: new AMap.LngLat(118.216513, 36.810216),
            // 将一张图片的地址设置为 icon
            // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
            // offset: new AMap.Pixel(-13, -30),
          });
          conmap.add([viaMarker]);
          return
        }
        let that = this
        AMap.convertFrom(([res.data.lng, res.data.lat]), this.gps_type, function (status, result) {
          if (result.info === 'ok') {
            var resLnglat = result.locations[0];
            // conMap.setCenter([resLnglat.lng, resLnglat.lat]); //设置地图中心点
            if (marker) {
              marker.setAngle(that.course);
              marker.setPosition([resLnglat.lng, resLnglat.lat]);
            } else {
              marker = new AMap.Marker({
                position: [resLnglat.lng, resLnglat.lat],
                content: '<img src="../../static/汽车相关-俯视车 (1).png" style="width:20px;height:20px;" />',
                angle: that.course,
              });
              if (map_status) {
                marker.setMap(conmap);
              }
            }

          }
        });
      });

    },
    //待处理列表
    getdata() {
      get_faultoder_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          for (let i = 0; i < this.listData.length; i++) {
            this.listData[i].status_type = {
              "0": "#F56C6C",
              "1": "#909399",
              "2": "#67C23A",
              "3": "#409EFF",
            }[this.listData[i].status]
            this.listData[i].status = {
              "0": "撤销",
              "1": "待处理",
              "2": "已处理",
              "3": "已转接",
            }[this.listData[i].status]
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //历史记录列表
    getSuccessdata() {
      get_history_order(this.successFormInline).then(
        (res) => {
          if (res["code"] === 0) {
            this.tableData = res.data.data;
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].status_type = {
                "2": "#67C23A",
                "3": "#409EFF",
              }[this.tableData[i].status]
              this.tableData[i].status = {
                "2": "已处理",
                "3": "已转接",
              }[this.tableData[i].status]
              this.tableData[i].description_type = {
                "2": "#67C23A",
                "3": "#409EFF",
              }[this.tableData[i].dd_description] || null
              this.tableData[i].dd_description = {
                "2": "提交",
                "3": "结束"
              }[this.tableData[i].dd_description] || null
            }
            this.page_parm.currentPage = this.successFormInline.page;
            this.page_parm.pageSize = this.successFormInline.limit;
            this.page_parm.total = res.data["total"];
          } else {
            this.$message.error(res["message"]);
          }
        }
      );
    },
    //编辑运维人员
    editClick() {
      get_faultoder_get_users().then((res) => {
        if (res["code"] === 0) {
          this.options = res.data;
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    searchSuccess() {
      this.successFormInline.page = 1;
      this.getSuccessdata();
    },
    getCurrentPerson() {
      get_faultoder_get_users().then((res) => {
        if (res["code"] === 0) {
          this.currentPersonOptions = res.data;
        }
      });
    },
    getPerson() {
      get_faultoder_get_users().then((res) => {
        if (res["code"] === 0) {
          this.PersonOptions = res.data;
        }
      });
    },
    handleClick() {
      if (this.activeName == 'first') {
        this.getdata();
        this.getCurrentPerson()
        this.formInline.page = 1;
      } else {
        this.getSuccessdata();
        this.getPerson()
        this.successFormInline.page = 1;
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    fautoderFather() {
      this.successFormInline.page = this.page_parm.currentPage;
      this.successFormInline.limit = this.page_parm.pageSize;
      this.getSuccessdata();
    },
    //显示编辑页面
    handleEdit(row) {
      this.editClick()
      this.dialogFormVisible = true;
      this.form.id = row.id;
    },
    //编辑提交方法
    submitEdit() {
      this.dialogFormVisible = false;
      get_faultoder_edit(this.form).then((res) => {
        if (res["code"] === 0) {
          this.form = {};
          this.getdata();
          this.$message.success(res["message"]);
        } else {
          this.form = {};
          this.$message.error(res["message"]);
        }
      });
    },
    //修改状态
    handleStatus(row) {
      this.deal = true;
      this.ruleForm.id = row.id
    },
    submitForm() {
      get_faultoder_switch_status(this.ruleForm).then((res) => {
        if (res["code"] === 0) {
          if (this.listData.length === 1) {
            if (this.formInline.page === 1) {
              this.getdata();
            } else {
              this.formInline.page = this.formInline.page - 1;
              this.getdata();
            }
          } else {
            this.getdata();
          }
          this.$message.success(res["message"]);
          this.deal = false;
        }
      });
    },
    handleSizeChange(val) {
      this.page_parm.pageSize = val;
      this.fautoderFather();
    },
    handleCurrentChange(val) {
      this.page_parm.currentPage = val;
      this.fautoderFather();
    },
    closeDialog() {
      this.deal = false;
      this.dialogFormVisible = false;
      this.show = false;
      map_status = false
      clearInterval(this.timer);
      conmap && conmap.destroy();
      marker = "";
    }
  },
};
</script>
<style>
.tabs_style {
  margin-top: 30px;
  width: 100% !important;
}

#container {
  width: 100%;
  height: 600px;
}

.car_jl {
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/worksheet_mn/WorkOrder_mn.vue